<template>
  <article
    :class="{
      'matchContainer': true,
      [className]: className,
    }"
    @click="openMatch"
  >

    <!-- begin matchInfo -->
    <div class="matchInfo  margin-top_33 relative parent row wrap shadow_spread">

      <h3 class="matchInfo__title font-weight_semibold font-size_12 parent centered width_fill">{{ leagueName }}</h3>
      <h4 class="matchInfo__subtitle font-weight_light font-size_10 parent centered width_fill">{{ leagueStage }}</h4>

      <!-- begin team -->
      <div class="team centered parent column">
        <h4 class="team__title croped_line text_centered font-size_14 font-weight_semibold">{{ leftTeamName }}</h4>
        <lazy-image
          :src="leftTeamLogo"
          class-name="team__logo order_first parent centered"
          relative/>
        <span class="font-weight_bold color_blue font-size_12">{{ leftTeamRatio }}</span>
      </div>
      <!-- end team -->

      <!-- begin matchMeta -->
      <div class="grow matchMeta parent column v-centered">
        <time
          :datetime="matchDate | formatDate('L')"
          class="parent column centered matchMetaTime">
          <span class="dayAndMonth font-size_10 font-weight_semibold">{{ matchDate | formatDate("D MMMM") }}</span>
          <span class="time">{{ matchDate | formatDate("HH:mm") }}</span>
        </time>
        <lazy-image
          :src="gameImage ? gameImage : gameImages.gameLogo"
          class-name="padding-top_small matchMeta__gameLogo parent h-centered relative order_first v-start"
          relative
          fit
        />
      </div>
      <!-- end matchMeta -->

      <!-- begin team -->
      <div class="team grow centered parent column">
        <h4 class="team__title croped_line text_centered font-size_14 font-weight_semibold">{{ rightTeamName }}</h4>
        <lazy-image
          :src="rightTeamLogo"
          class-name="team__logo order_first parent centered"
          relative />
        <span class="font-weight_bold color_blue font-size_12">{{ rightTeamRatio }}</span>
      </div>
      <!-- end team -->
      <lazy-image
        :src="gameBackground ? gameBackground : gameImages.gameBackground"
        class-name="position_base"
        is-image-fill-container
        absolute/>
    </div>
    <!-- end matchInfo -->
  </article>
</template>

<script>
import { transformDate } from "@/constants/pureFunctions";
import { csgo, dota, hs, lol, ow } from "@/assets/images/icons";
import {
  csgo_bg,
  dota_bg,
  hs_bg,
  lol_bg,
  ow_bg
} from "@/assets/images/backgrounds";
import { games } from "@/constants/conf";

export default {
  name: "MatchInfo",
  components: {},
  mixins: [],
  props: {
    className: {
      type: String,
      required: false,
      default: ""
    },
    modifier: {
      type: String,
      required: false,
      default: ""
    },
    leagueName: {
      type: String,
      required: true
    },
    leagueStage: {
      type: String,
      required: false,
      default: "Group Stage"
    },
    leftTeamName: {
      type: String,
      required: true
    },
    leftTeamLogo: {
      type: String,
      required: true
    },
    leftTeamRatio: {
      type: Number,
      required: true
    },
    rightTeamName: {
      type: String,
      required: true
    },
    rightTeamLogo: {
      type: String,
      required: true
    },
    rightTeamRatio: {
      type: Number,
      required: true
    },
    matchDate: {
      type: [Date, String],
      required: true
    },
    gameId: {
      type: String,
      required: true
    },
    gameImage: {
      type: [String, Boolean],
      required: true
    },
    gameBackground: {
      type: [String, Boolean],
      required: true
    },
    matchUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    gameImages() {
      let gameLogo = "";
      let gameBackground = "";

      switch (this.gameId) {
        case games.dota:
          gameLogo = dota;
          gameBackground = dota_bg;
          break;
        case games.csgo:
          gameLogo = csgo;
          gameBackground = csgo_bg;
          break;
        case games.hs:
          gameLogo = hs;
          gameBackground = hs_bg;
          break;
        case games.lol:
          gameLogo = lol;
          gameBackground = lol_bg;
          break;
        case games.ow:
          gameLogo = ow;
          gameBackground = ow_bg;
          break;
        default:
        // throw new TypeError(`There is no the game with id ${this.gameId}.`);
      }

      return {
        gameLogo: this.gameImage || gameLogo,
        gameBackground: this.gameBackground || gameBackground
      };
    }
  },
  methods: {
    openMatch() {
      this.$store.dispatch("popups/openMatch", this.matchUrl);
    }
  }
};
</script>

<style lang="sass" scoped>
@import '../assets/sass/conf/_colors.sass'
@import '../assets/sass/conf/_sizes.sass'
@import '../assets/sass/conf/_easing.sass'

.matchContainer
  max-width: em(262.5)
  display: inline-block

.matchInfo
  padding: em(10) em(14) 1.5em em(25)
  margin-bottom: em(21)
  min-height: em(157)

  will-change: transform
  transition: 270ms transform $sharp

  &:hover, &:focus
    transform: scale(1.05)




.matchInfo__subtitle
  margin-bottom: em(7)

.team
  max-width: 50px
  min-height: 87px

  &__title
    max-width: 75px

  &__logo
    max-width: 48px
    max-height: 37px
    margin-bottom: em(11)

.matchMeta
  margin: 0 em(18)
  max-width: em(70)

  &__gameLogo
    max-width: em(17)
    max-height: em(50)

</style>



// WEBPACK FOOTER //
// src/components/MatchInfo.vue